import { render, staticRenderFns } from "./MoreActionsMenu.vue?vue&type=template&id=19d60fce&scoped=true"
import script from "./MoreActionsMenu.vue?vue&type=script&lang=js"
export * from "./MoreActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./MoreActionsMenu.vue?vue&type=style&index=0&id=19d60fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d60fce",
  null
  
)

export default component.exports